import React from 'react'
import { Helmet } from 'react-helmet'

/**
 * Structured Data Component - Schema.org JSON-LD
 * Helps search engines understand the content and improves SEO
 */
export function StructuredData() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "BuyMeABody.robotics",
    "url": "https://treasury-demo.preview.emergentagent.com",
    "logo": "https://treasury-demo.preview.emergentagent.com/logo512.png",
    "description": "Revolutionary blockchain-powered robot economy platform with $BODY token staking on Solana",
    "foundingDate": "2025",
    "sameAs": [
      "https://x.com/buymeabody",
      "https://www.instagram.com/buymeabody.robotics/",
      "https://www.tiktok.com/@buymeabody.roboti",
      "https://discord.gg/ywV3CpKY"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Support",
      "availableLanguage": "English"
    }
  }

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "BuyMeABody.robotics",
    "url": "https://treasury-demo.preview.emergentagent.com",
    "description": "Stake $BODY tokens to earn up to 15% APY. Join the future of robotics economy with blockchain-powered staking",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://treasury-demo.preview.emergentagent.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  }

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "FinancialProduct",
    "name": "$BODY Token Staking",
    "description": "Stake $BODY tokens on Solana blockchain and earn rewards with three flexible plans: Flexible (5% APY), Standard (10% APY), and Premium (15% APY)",
    "brand": {
      "@type": "Brand",
      "name": "BuyMeABody.robotics"
    },
    "offers": [
      {
        "@type": "Offer",
        "name": "Flexible Staking Plan",
        "description": "30-day lock period, 5% APY, minimum 100 $BODY",
        "price": "0",
        "priceCurrency": "USD"
      },
      {
        "@type": "Offer",
        "name": "Standard Staking Plan",
        "description": "60-day lock period, 10% APY, minimum 500 $BODY",
        "price": "0",
        "priceCurrency": "USD"
      },
      {
        "@type": "Offer",
        "name": "Premium Staking Plan",
        "description": "90-day lock period, 15% APY, minimum 1000 $BODY",
        "price": "0",
        "priceCurrency": "USD"
      }
    ]
  }

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://treasury-demo.preview.emergentagent.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Staking",
        "item": "https://treasury-demo.preview.emergentagent.com/#staking"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Tokenomics",
        "item": "https://treasury-demo.preview.emergentagent.com/#robotnomics"
      },
      {
        "@type": "ListItem",
        "position": 4,
        "name": "Roadmap",
        "item": "https://treasury-demo.preview.emergentagent.com/#roadmap"
      }
    ]
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  )
}
